// extracted by mini-css-extract-plugin
module.exports = {"container":"TribesWorkbook_container__dOzMu","photo":"TribesWorkbook_photo__RBNlb","leftSide":"TribesWorkbook_leftSide__2ysN_","rightSide":"TribesWorkbook_rightSide__Qk3K3"};